import 'owl.carousel';

function check_active_slide( slider )
{
	slider.on('translated.owl.carousel', function(event) {

		let active_slide = $(this).find('.owl-item.active');
		let active_hash	 = active_slide.find('.project-slider__slide').attr('data-hash');
		let active_btn	 = $('.project-slider-nav').find('a[href="#' + active_hash + '"]');

		active_btn.addClass('active').siblings().removeClass('active');

	});
}

export function sliders()
{
		let sliders = $('.slider');

		sliders.each(function(){

				//Change the options here - you can use data-* tags to specify different values for different sliders

				let nav = false;
				let auto_slide = false;
				let mobile_nav = false;
				let mobile_autoslide = false;

				let _this = $(this);

				let data_nav = $(this).attr('data-nav');
				let data_mobile_nav = $(this).attr('data-mobilenav');
				let data_slide = $(this).attr('data-autoslide');
				let data_hash  = $(this).attr('data-url');
				let data_mobautoslide = $(this).attr('data-mobautoslide');

				if( data_nav.length > 0)
				{
					nav = $.parseJSON(data_nav);
				}

				if( data_mobile_nav.length > 0)
				{
					mobile_nav = $.parseJSON(data_mobile_nav);
				}

				if( data_slide != null)
				{
					auto_slide = $.parseJSON(data_slide);
				}

				if( data_mobautoslide != null)
				{
					mobile_autoslide = $.parseJSON(data_mobautoslide);
				}

				if( data_hash != null )
				{
					check_active_slide(_this);
				}

				let options =
				{
					items: 1,
					dots: false,
					loop: true,
					URLhashListener: true,
					nav: false,
					autoplay: auto_slide,
					mouseDrag: false,
					animateOut: 'fadeOut',
					navText: [
						'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 30"><path d="M10,30h10V20H10V30z M0,20h10V10H0L0,20z M10,10h10V0L10,0V10z"/></svg>',
						'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 30"><path d="M10,0L0,0l0,10h10V0z M20,10H10v10h10V10z M10,20H0l0,10h10V20z"/></svg>',
					],

					responsive :
					{
						0 : {
							nav: false,
							touchDrag: true,
							autoplay: mobile_autoslide,
						},
						900 : {
							//nav: nav,
							nav: false,
							touchDrag: false,
							autoplay: auto_slide,
						},
					}
				};

				$(this).owlCarousel(options);
		})
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js